<template>
  <div v-if="!banners || banners.length === 0" class="card card-lg col-4">
    <div class="card-body text-center">
      <IconAlertCircle class="text-muted mb-2" size="3em" />
      <h3 class="text-muted text-center">{{ $t('orders.details.banners.empty') }}</h3>
    </div>
  </div>
  <div class="row row-cards" id="banners" v-else>
    <div class="col-sm-6 col-lg-3" v-for="banner in banners" :key="banner.id">
      <BannerPreview
        :banner="banner"
        :class="{ 'cursor-pointer': banner.designer_template_id }"
        :show-no-edit-flag="true" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { fetchOrderBanners } from '@/api/banner';
import BannerPreview from '@/components/banners/BannerPreview.vue';
import type { IBanner } from '@/types/banner';
import type { Order } from '@/types/types';
import { IconAlertCircle } from '@tabler/icons-vue';
import { onMounted, ref } from 'vue';

const banners = ref<IBanner[]>();

const props = defineProps<{
  orderId: string;
  order: Order;
}>();

onMounted(() => {
  fetchOrderBanners(props.orderId).then((res) => {
    banners.value = res?.data || [];
  });
});
</script>
